import styled from 'styled-components'

export const StyledTopBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`
